import { render, staticRenderFns } from "./dashboard-reporting.vue?vue&type=template&id=04d2e2e0&"
import script from "./dashboard-reporting.vue?vue&type=script&lang=js&"
export * from "./dashboard-reporting.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-reporting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports